<template>
    <div>
        <p>For my senior project at the CU Boulder I created a small start up called Nimb.ly. It's purpose was to solve a scheduling and staffing nightmare found in the catering industry. My partner and I entered Nimb.ly into an event called New Venture Challenge (NVC) which is put on by the University of Colorado. The event was preceded by six months of preparation doing interviews with catering business owners, building product demos, and perfecting a pitch for the culminating presentations.</p>
        <p>I pitched Nimb.ly to a series of panels of judges and made it to the NVC finals which was hosted at Boulder theater in front of an audience of 1000+. Ultimately we finished 5th out of 130+ start ups, and we were awarded <strong>$11,000</strong> total.</p>
        <photo-shelf>
            <photo-frame
                v-for="photo in photos" :key="photo.src"
                class="frame"
                :src="photo.src"
                :text="photo.text"
                :location="photo.location"
                :location-href="photo.locationHref"
            />
        </photo-shelf>
        <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
    </div> 
</template>

<script>
    import PhotoShelf from '@/components/PhotoShelf'
    import PhotoFrame from '@/components/PhotoFrame'
    import LogoScroller from '@/components/LogoScroller'
    export default {
        name: "NvcTimeline",
        components: {
            PhotoFrame,
            PhotoShelf,
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'python',
                    'node',
                    'express',
                    'vue',
                    'typescript',
                    'javascript',
                    'html5',
                    'css3',
                    'sass',
                    'git_hub',
                    'git'
                ]
            }
        },
        computed: {
            photos () {
                return [
                    {
                        src: this.getImageUrl('NVC_Brandon_Aguirre.jpeg'),
                        text: 'Right before speaking on stage at Boulder Theater.',
                        location: 'Boulder Theater',
                        locationHref: 'https://goo.gl/maps/6RqrF5MxmL4cLZeL7'
                    },
                    {
                        src: this.getImageUrl('Boulder_Theater_NVC2019.jpg'),
                        text: 'Boulder Theater holding 1000+ audience members at the NVC Finals 2019.',
                        location: 'Boulder Theater',
                        locationHref: 'https://goo.gl/maps/6RqrF5MxmL4cLZeL7'
                    }
                ]
            }
        },
        methods: {

        }    
    }
</script>

<style lang="scss">
    
</style>